import { Text } from '@adc/parallax-component-library';

import { MainContainer } from '~/components/utility';

export const NotFoundPage = () => (
  <MainContainer
    backgroundColor="$surface.background"
    justifyContent="center"
    alignItems="center"
    padding="$4"
    gap="$3"
  >
    <Text tag="h1" type="$h1.default">
      Page Not Found
    </Text>
    <Text type="$bodySmall.default" textAlign="center">
      The path you are looking for does not exist.
    </Text>
  </MainContainer>
);
